module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-5ae23ad29b67289a1375d2043e289c52.eot";